import { Box, Container, Grid, IconButton, useTheme } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useEffect, useState } from "react";

import { Filter } from "assets/Icon";
import FilterBasketHistory from "./components/FilterBasketHistory";
import BasketHistoryTabs from "./components/BasketHistoryTabs";
import Pagination from "components/Pagination";
import useIsMobileView from "hooks/useIsMobileView";
import { useSearchParams } from "react-router-dom";
import useDispatch from "hooks/useDispatch";
import { getBasketHistoryForm, getBasketHistoryList } from "store/slices/wallet/walletSlice";
import { formatDateToJalali } from "utils/helpers/time";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import TableBasketHistory from "./components/TableBasketHistory";
import { useSelector } from "react-redux";
import BoxBasketHistory from "./components/BoxBasketHistory";
import BackButton from "components/BackButton";

function BasketHistory() {
  const theme = useTheme();
  const dispatch = useDispatch()
  const isMobileView = useIsMobileView();

  const basketHistoryList = useSelector((state) => state.wallet.basketHistoryList)

  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState();

  const [searchParams, setSearchParams] = useSearchParams();
  const pageNumber = +searchParams.get("page") || 1;
  const pageSize = +searchParams.get("perPage") || 10;
  const typeId = +searchParams.get("typeId") || 0;

  const defaultValues = {
    dateFrom: "",
    dateTo: "",
    repayId: 0,
    transferId: 0,
    coinId: -1,
    basketId: -1
  };

  const methods = useForm({ defaultValues });
  const { watch } = methods;

  const dateFrom = watch("dateFrom");
  const dateTo = watch("dateTo");
  const repayId = watch("repayId");
  const transferId = watch("transferId");
  const coinId = watch("coinId");
  const basketId = watch("basketId");

  const handleGetHistoryList = async ({ pageNumber, pageSize }) => {
    setLoading(true);

    await dispatch(getBasketHistoryList({
      typeId,
      coinId,
      dateFrom: formatDateToJalali(dateFrom),
      dateTo: formatDateToJalali(dateTo),
      transferId,
      repayId,
      pageNumber,
      pageSize,
      basketId
    }))

    setLoading(false);
  };

  const handleChangeHistoryTab = (_, newValue) => {
    setSearchParams({
      typeId: newValue,
    });
  };

  const handleChangePaginate = ({ page, perPage }) => {
    handleGetHistoryList({ pageNumber: page, pageSize: perPage });
  };

  useEffect(() => {
    dispatch(getBasketHistoryForm())
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    handleGetHistoryList({ pageSize, pageNumber });
    // eslint-disable-next-line
  }, [repayId, transferId, coinId, dateFrom, dateTo, typeId, basketId]);

  return (
    <Container maxWidth="100%">
      <Grid container>
        <Grid item xs={12} sx={{ display: { md: 'none', xs: 'block' } }}>
          <BackButton text="Wallet History" to="/wallet" />
        </Grid>

        <BasketHistoryTabs
          handleChange={handleChangeHistoryTab}
          typeId={typeId}
        />

        <Grid item xs={12}>
          <Box display="flex" flexDirection="row-reverse" mb={2}>
            <IconButton
              onClick={() => {
                setShowFilter((v) => !v);
              }}
              aria-label="filter"
            >
              <Filter color={theme.palette.text.main} />
            </IconButton>
          </Box>

          {showFilter && (
            <FormProvider {...methods}>
              <form>
                <FilterBasketHistory
                  typeId={typeId}
                />
              </form>
            </FormProvider>
          )}
        </Grid>

        <Grid item xs={12}>
          {isMobileView ? (
            <>
              {basketHistoryList?.data?.map((basket) => (
                <BoxBasketHistory basket={basket} />
              ))}
            </>
          ) : (
            <>
              {!loading ? (
                <TableBasketHistory />
              ) : (
                <TableSkeleton />
              )}
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <Pagination
            count={basketHistoryList?.totalPages}
            perPage={basketHistoryList?.pageSize}
            onChange={handleChangePaginate}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default BasketHistory;
